// extracted by mini-css-extract-plugin
export default {"snackbar":"epl7E5N5wLGUGcUlKX7A","text":"yCt90PixXnX1wggSAuy3"};